import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types'

const TextFieldGroup = ({ field, value, label, error, type, maxLength, onChange, disabled, autoComplete, placeholder }) => {
    return (
        <div className={classnames('form-group', { 'has-error': error })}>
            <label className="control-label">{label}</label>
            <input
                onChange={onChange}
                value={value}
                type={type}
                name={field}
                disabled={disabled}
                className="form-control"
                maxLength={maxLength}
                autoComplete={autoComplete}
                placeholder={placeholder}
            />
            {error && <span className="help-block">{error}</span>}
        </div>
    )
}

TextFieldGroup.propTypes = {
    field: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string,
    error: PropTypes.string,
    type: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    autoComplete: PropTypes.string,
    placeholder: PropTypes.string,
}

TextFieldGroup.defaultProps = {
    type: 'text'
}

export default TextFieldGroup;